<template>
    <div style="display: flex; justify-content: space-evenly">
        <div id="Paraklassenverwaltung" style="width:600px">
            <h2>Stammdaten Paraklassen</h2>
            <Grid ref="grid"
                  :style="{height: '320px'}"
                  :data-items="getData"
                  :edit-field="'inEdit'"
                  @rowclick="rowClick"
                  :columns="columns">
                <grid-toolbar>
                    <div @click="closeEdit">
                        <kbutton title="Add new" :theme-color="'primary'" @click='addRecord'>
                            Add new
                        </kbutton>
                    </div>
                </grid-toolbar>
            </Grid>



            <!--<div id="Toolbar">
                <Toolbar>
                    <kbutton :size="'large'" :icon="'plus-circle'" @click="onNeuClick" class="k-button">Neu</kbutton>
                    <kbutton :size="'large'" :icon="'edit'" @click="onBearbeitenClick" class="k-button">Bearbeiten</kbutton>
                    <kbutton :size="'large'" :icon="'delete'" @click="onLoeschenClick" class="k-button">L�schen</kbutton>
                </Toolbar>
            </div>-->
            <!--<div id="Grid">
        <kendo-datasource ref="datasourceGrid"
                          :transport-read-url="gridurl"
                          :transport-read-data-type="'jsonp'"
                          :schema-model-id="'Prim'"
                          :schema-model-fields="schemaModelFields">
        </kendo-datasource>
        <kendo-grid :height="500"
                    :data-source-ref="'datasourceGrid'"
                    :selectable="true"
                    ref="grid"
                    :filterable-mode="'row'"
                    v-on:change="onChange">
            <kendo-grid-column :field="'Prim'"
                               :title="'Prim'"
                               :width="20"
                               :hidden="true">
            </kendo-grid-column>
            <kendo-grid-column :field="'Klasse'"
                               :title="'Klasse'"
                               :width="40">
            </kendo-grid-column>
            <kendo-grid-column :field="'Bezeichnung'"
                               :title="'Bezeichnung'"
                               :width="60">
            </kendo-grid-column>
        </kendo-grid>
    </div>-->
            <NotificationGroup :style="{
                    bottom: 0,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    'align-items': 'flex-start'
                    }">
                <Fade :appear="success">
                    <Notification v-if="success" :type="{ style: 'success', icon: true }">
                        <span>Speichern erfolgreich!</span>
                    </Notification>
                </Fade>
                <Fade :appear="error">
                    <Notification v-if="error" :type="{ style: 'error', icon: true }">
                        <span>Es ist ein Fehler aufgetreten! Bitte melde dich beim Administrator.</span>
                    </Notification>
                </Fade>
            </NotificationGroup>
        </div>
        <br />
    </div>
</template>

<script>
    //import '@progress/kendo-ui';
    //import '@progress/kendo-theme-default/dist/all.css';
/*    import kendo from '@progress/kendo-ui';*/
/*    import { KendoDataSource } from '@progress/kendo-datasource-vue-wrapper';*/
    import { Button } from '@progress/kendo-vue-buttons';
/*    import { Grid, GridColumn } from '@progress/kendo-grid-vue-wrapper';*/
    import { Fade } from '@progress/kendo-vue-animation';
    import { Notification, NotificationGroup } from '@progress/kendo-vue-notification';
/*    import { Input } from "@progress/kendo-vue-inputs";*/
    //import {
    //    Toolbar,
    //    ToolbarItem,
    //    ToolbarSeparator,
    //    ToolbarSpacer,
    //    ButtonGroup
    //} from "@progress/kendo-vue-buttons";
/*    import config from "@/appdata/config.json";*/
/*    import axios from 'axios';*/
    /*Test*/
    import { Grid, GridToolbar } from '@progress/kendo-vue-grid';

    export default {
        components: {
/*            'kendo-datasource': KendoDataSource,*/
            'kbutton': Button,
            //'kendo-grid': Grid,
            //'kendo-grid-column': GridColumn,
/*            'k-input': Input,*/
            //Toolbar,
            //ToolbarItem,
            //ToolbarSeparator,
            //ToolbarSpacer,
            //ButtonGroup,
            Grid: Grid,
            'grid-toolbar': GridToolbar,
            Fade,
            Notification,
            NotificationGroup
        },
        data: function () {
            return {
                //dialogVisible: false,
                //gridurl: '',
                //urlDelete: '',
                //urlEdit: '',
                //selectedItem: null,
                //selectedPrim: 0,
                //grid: null,
                //schemaModelFields: {
                //    Prim: { type: 'number', editable: false },
                //    Klasse: { validation: { required: true } },
                //    Bezeichnung: { validation: { required: true } }
                //},
                updatedData: [],
                editID: null,
                group: [{ field: 'UnitsInStock' }],
                expandedItems: [],
                columns: [
                    { field: 'ProductID', editable: false, title: 'ID', width: '80px' },
                    { field: 'ProductName', title: 'Name' },
                    { field: 'FirstOrderedOn', editor: 'date', title: 'First Ordered', format: '{0:d}' },
                    { field: 'UnitsInStock', title: 'Units', width: '150px', editor: 'numeric' },
                    { field: 'Discontinued', title: 'Discontinued', editor: 'boolean' }
                ],
                gridData: [{
                    "ProductID": 1,
                    "ProductName": "Chai",
                    "UnitsInStock": 39,
                    "Discontinued": false,
                    "FirstOrderedOn": new Date(1996, 8, 20)
                }, {
                    "ProductID": 2,
                    "ProductName": "Chang",
                    "UnitsInStock": 17,
                    "Discontinued": false,
                    "FirstOrderedOn": new Date(1996, 7, 12)
                }, {
                    "ProductID": 3,
                    "ProductName": "Aniseed Syrup",
                    "UnitsInStock": 13,
                    "Discontinued": false,
                    "FirstOrderedOn": new Date(1996, 8, 26)
                }, {
                    "ProductID": 4,
                    "ProductName": "Chef Anton's Cajun Seasoning",
                    "UnitsInStock": 53,
                    "Discontinued": false,
                    "FirstOrderedOn": new Date(1996, 9, 19)
                    }],
                success: false,
                error: false
            };
        },
        computed: {
            getData() {
                return this.gridData.map(
                    (item) => Object.assign({ inEdit: item.ProductID === this.editID }, item));
            }
        },
        mounted() {
 /*           window.$ = kendo.jQuery;*/
 /*           this.grid = this.$refs.grid.kendoWidget();*/
        },
        created() {
            this.getData();
            //this.gridurl = config[0].ServiceUrl + config[0].ServiceUrlPort + "/Paraklassen"
            //this.urlDelete = config[0].ServiceUrl + config[0].ServiceUrlPort + "/Paraklassen"
            //this.urlCreate = config[0].ServiceUrl + config[0].ServiceUrlPort + "/Paraklassen"
            //this.urlEdit = config[0].ServiceUrl + config[0].ServiceUrlPort + "/Paraklassen"
        },
        methods: {
            //onChange(ev) {
            //    var selectedIndex = ev.sender.select();
            //    this.selectedItem = ev.sender.dataItem(selectedIndex).toJSON();
            //    this.selectedPrim = ev.sender.dataItem(selectedIndex).Prim;
            //    console.log("----------> selectedIndex", selectedIndex);
            //    console.log("----------> this.selectedItem", this.selectedItem);
            //    console.log("----------> this.selectedPrim", this.selectedPrim);
            //},
            //onNeuClick() {
            //    /*this.dialogVisible = true;*/
            //    const parameters = {
            //        "klasse": 'P88',
            //        "bezeichnung": 'Mein Test',
            //    };
            //    axios.post(this.urlCreate, parameters)
            //        .then((response) => {
            //            console.log("----------> success", response);
            //        })
            //        .catch((error) => {
            //            console.log("---------> error", error);
            //        });
            //},
            //onBearbeitenClick() {
            //    this.dialogVisible = true;
            //    this.$refs.Klasse = 'Test';
            //    console.log("----------> this.$refs.Klasse", this.$refs.Klasse);
            //    //const parameters = {
            //    //    "klasse": 'P88',
            //    //    "bezeichnung": 'Mein Test2',
            //    //};
            //    //axios.patch(this.urlEdit, parameters )
            //    //    .then((response) => {
            //    //        console.log("----------> success", response);
            //    //    })
            //    //    .catch((error) => {
            //    //        console.log("---------> error", error);
            //    //    });

            //},
            //onLoeschenClick() {
            //    axios.delete(config[0].ServiceUrl + config[0].ServiceUrlPort + "/Paraklassen?prim=" + this.selectedPrim)
            //        .then((response) => {
            //            console.log("----------> success", response);
            //        })
            //        .catch((error) => {
            //            console.log("---------> error", error);
            //        });
            //    const datasourceGrid = this.$refs.datasourceGrid.kendoWidget();
            //    datasourceGrid.read();
            //    this.$refs.grid.setDataSource(datasourceGrid);
            //    this.grid = this.$refs.grid.kendoWidget();
            //    this.grid.refresh();
            //},
            showNotificationSuccess() {
                /*Meldung anzeigen*/
                this.success = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.success = false;
                }, 3000);
            },
            showNotificationError() {
                /*Meldung anzeigen*/
                this.error = true;
                /*Meldung automatisch ausblenden*/
                setTimeout(() => {
                    this.error = false;
                }, 3000);
            },
            //onSaveClick() {
            //    console.log("------------> save clicked");
            //    this.dialogVisible = false;
            //},
            //onCancelClick() {
            //    console.log("------------> cancel clicked");
            //    this.dialogVisible = false;
            //},
            rowClick: function (e) {
                this.editID = e.dataItem.ProductID;
                e.dataItem.inEdit = true;
            },
            closeEdit(e) {
                if (e.target === e.currentTarget) {
                    this.editID = null;
                }
            },
            addRecord() {
                const newRecord = { ProductID: this.gridData.length + 1 };
                const data = this.gridData.slice();
                data.unshift(newRecord);
                this.gridData = data;
                this.editID = newRecord.ProductID;
            }
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @import '../css/main.css';
</style>